import { EntitySection } from './entity-section.component';

import { Skeleton } from '@/components/ui/skeleton.component';
import { Star } from '@/components/ui/star.component';

export function CommentLoading() {
  return (
    <EntitySection>
      <Skeleton className="w-32 h-5" />
      <div className="mt-2 flex items-center gap-1">
        <Star rating={0} />
        <Skeleton className="w-20 h-3" />
      </div>

      <div className="mt-4 space-y-2">
        {Array.from({ length: 3 }).map((_, i) => (
          <Skeleton className={`h-2.5 ${i === 2 ? 'w-1/3' : 'w-full'}`} key={i} />
        ))}
      </div>
    </EntitySection>
  );
}
